/**
 * Masks sensitive information, showing only the last 3 characters
 * @param value The string to mask
 * @param showLastChars Number of characters to show at the end (default: 3)
 * @returns Masked string
 */
export const maskSensitiveInfo = (value: string, showLastChars: number = 3): string => {
  if (!value) return '';
  if (value.length <= showLastChars) return value;
  return '*'.repeat(value.length - showLastChars) + value.slice(-showLastChars);
}; 